import React, { useEffect, useState } from "react";
import ListaFichajes from "./ListaFichajes";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "context/AuthProvider";
import { apiFichajesService } from "services/apiFichajesService";
import { apiexportacionService } from "services/apiExportacionService";
import FiltroFichaje from "./FiltroFichaje";

import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,

} from "reactstrap";

import FichajeManual from "./FichajeManual";
import { showAppAlert } from "components/common/AppAlerts";

const ListaFichajesImpl = () => {
  //empleado
  const { empresa } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();
  const today = new Date().toISOString().split("T")[0];
  const [fechaDesde, setFechaDesde] = useState(today);
  const [fechaHasta, setFechaHasta] = useState(today);
  const [update, setUpdate] = useState(false);
  const [estadoVista, setEstadoVista] = useState("ACTIVOS");
  const [showManualOptions, setShowManualOptions] = useState(false);

  const [fichajes, setFichajes] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);

  useEffect(() => {
    setCurrentPage(0);
  }, [fechaDesde, fechaHasta, id, estadoVista]);

  useEffect(() => {
    const fetchData = async () => {
      if (fechaDesde && fechaHasta) {
        try {
          const response = await apiFichajesService.getFichajesEmpleadByEmpleadoIdAndDateRangePageable(
            empresa.id,
            id,
            fechaDesde,
            fechaHasta,
            estadoVista,
            currentPage,
            10
          );
          setFichajes(response?.content || []);
          setTotalPage(response?.totalPages || 0);
        } catch (err) {
          console.error("Error loading fichajes:", err);
          setFichajes([]);
          setTotalPage(0);
        }
      }
    };
    fetchData();
  }, [fechaDesde, fechaHasta, update, empresa.id, id, currentPage, estadoVista]);

  const handleUpdate = () => {
    setUpdate(!update);
  }

  const handleExportarTrazabilidad = async () => {
    try {
      await apiexportacionService.getInformeTrazabilidadFichajes(
        empresa.id,
        fechaDesde,
        fechaHasta,
        id,
        estadoVista
      );
    } catch (error) {
      showAppAlert(error?.message || "No se pudo descargar el informe de trazabilidad.", "error");
    }
  };

  const getTitle = () => {
    if (estadoVista === "ELIMINADOS") {
      return "Fichajes eliminados";
    }
    if (estadoVista === "TODOS") {
      return "Todos los fichajes";
    }
    return "Fichajes activos";
  };

  return (
    <>
      <FiltroFichaje
        fechaDesde={fechaDesde}
        setFechaDesde={setFechaDesde}
        fechaHasta={fechaHasta}
        setFechaHasta={setFechaHasta}
        estadoVista={estadoVista}
        setEstadoVista={setEstadoVista}
        setShowManualOptions={setShowManualOptions}
      ></FiltroFichaje>

      {showManualOptions ? (
        <Card className="mt-2">
          <CardBody>
            <FichajeManual empleadoId={id} handleUpdate={handleUpdate}></FichajeManual>
          </CardBody>
        </Card>
      ) : null}

      <Card className="mt-2">
        {fichajes.length > 0 ? (
          <ListaFichajes
            title={getTitle()}
            fichajes={fichajes}
            administrar={estadoVista === "ACTIVOS"}
            handleUpdate={handleUpdate}
            showTraceability={estadoVista !== "ACTIVOS"}
            currentPage={currentPage}
            totalPage={totalPage}
            setCurrentPage={setCurrentPage}
          ></ListaFichajes>
        ) : (
          <CardBody>
            <Col>Sin fichajes...</Col>
          </CardBody>
        )}
        <CardFooter className="text-right">
          <Button
            color="primary"
            className="mr-2"
            onClick={handleExportarTrazabilidad}
          >
            Exportar trazabilidad PDF
          </Button>
          <Button
            color="secondary"
            onClick={() => navigate("/admin/empleados")}
          >
            Volver
          </Button>
        </CardFooter>
      </Card>

      
    </>
  );
};

export default ListaFichajesImpl;

